import { Component, OnInit, ViewChild } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';
import { AgentModalComponent } from '../agent-modal/agent-modal.component';

@Component({
  selector: 'app-agent-grid',
  templateUrl: './agent-grid.component.html',
  styleUrls: ['./agent-grid.component.scss']
})
export class AgentGridComponent implements OnInit {
  private _serviceSubscription;

  @ViewChild(AgentModalComponent, null) child:AgentModalComponent;

  page: number = 0;
  totalPages: number = 0;
  viewsPerPage: number = 10;
  tableData: any = [];
  orderProperty: any = "CertifiedDate";
  orderAsc: boolean = false;

  constructor(
    public loadingSvc: LoadingService,
    public dataSvc: DataService
  ) { }

  ngOnInit() {
    this.loadData();
    this._serviceSubscription = this.dataSvc.searchAppliedEmitter.subscribe({
      next: (event: boolean) => {
        this.loadData();
      }
    });
    /*setInterval(() => {
      this.loadData();
    }, 500);*/
  }

  loadData() {
    var totalPages = Math.ceil(this.dataSvc.filteredData.length / this.viewsPerPage);
    if (totalPages != this.totalPages) {
      this.page = 0;
      this.totalPages = totalPages;
    }
    var filteredData = this.dataSvc.filteredData;

    if (this.orderProperty != "") {
      if (this.orderAsc){
        filteredData.sort((a,b) => (a[this.orderProperty] > b[this.orderProperty]) ? 1 : ((b[this.orderProperty] > a[this.orderProperty]) ? -1 : 0));
      } else {
        filteredData.sort((a,b) => (a[this.orderProperty] < b[this.orderProperty]) ? 1 : ((b[this.orderProperty] < a[this.orderProperty]) ? -1 : 0));
      }
    }

    this.tableData = filteredData.slice((this.page)*this.viewsPerPage, (this.page+1)*this.viewsPerPage);
    this.dataSvc.pageUrl = "agents";
  }

  viewsPerPageChange() {
    this.dataSvc.viewsPerPage = this.viewsPerPage;
    this.loadData();
  }

  orderBy(property) {
    if (property == this.orderProperty) {
      this.orderAsc = !this.orderAsc;
    } else {
      this.orderProperty = property;
    }
  }

  nextPage() {
    this.page++;
    this.loadData();
  }

  previousPage() {
    this.page+=-1;
    this.loadData();
  }

  lastPage() {
    this.page = this.totalPages-1;
    this.loadData();
  }

  firstPage() {
    this.page = 0;
    this.loadData();
  }

  viewUser(u) {
    this.loadingSvc.changeLoading("agent-grid.viewUser", true);
    this.child.loadDetails(u);
  }
}
